$('.block__new-casestudy-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: '90px',
  arrows: true,
  prevArrow: $('.block__image-width-slider-arrows .arrow_prev'),
  nextArrow: $('.block__image-width-slider-arrows .arrow_next'),
  infinite: true,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        centerMode: true,
        centerPadding: '60px'
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
        centerPadding: '28px'
      }
    }
  ]
});